var i,
  swiper = new Swiper(".mySwiperr", {
    slidesPerView: 1,
    loop: !0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  }),
  swiper = new Swiper(".collectionimage", {
    loop: !0,
    nextButton: ".swiper-button-next",
    prevButton: ".swiper-button-prev",
    slidesPerView: 3,
    paginationClickable: !0,
    spaceBetween: 20,
    autoplay: { delay: 5e3, disableOnInteraction: !1 },
    breakpoints: {
      1920: { slidesPerView: 3, spaceBetween: 1 },
      1028: { slidesPerView: 3, spaceBetween: 1 },
      480: { slidesPerView: 1, spaceBetween: 1 },
      320: { slidesPerView: 1, spaceBetween: 1 },
    },
  }),
  coll = document.getElementsByClassName("collapsible");
for (i = 0; i < coll.length; i++)
  coll[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var e = this.nextElementSibling;
    "block" === e.style.display
      ? (e.style.display = "none")
      : (e.style.display = "block");
  });
var swiper = new Swiper(".responsive-carousel", {
  loop: !0,
  nextButton: ".swiper-button-next",
  prevButton: ".swiper-button-prev",
  slidesPerView: 1,
  paginationClickable: !0,
  spaceBetween: 20,
  autoplay: { delay: 5e3, disableOnInteraction: !1 },
  breakpoints: {
    1920: { slidesPerView: 5, spaceBetween: 27 },
    1028: { slidesPerView: 5, spaceBetween: 27 },
    480: { slidesPerView: 3, spaceBetween: 10 },
    320: { slidesPerView: 2, spaceBetween: 10 },
  },
});
